// ---------------------------------------------------------------------------
// Site config — edit the values below, nothing else needs to change.
// ---------------------------------------------------------------------------

// Your Razorpay Payment Link (create one at https://dashboard.razorpay.com
// → Payment Links → + Create Payment Link → fixed amount ₹3,500).
// Every "Enroll Now" button on the site sends the visitor here.
export const RAZORPAY_PAYMENT_LINK = "https://pages.razorpay.com/pl_NNSoPeCiP7slLZ/view";

// Your Meta (Facebook) Pixel ID, found in Events Manager.
export const META_PIXEL_ID = "636528794570441";

// Where the "Click here to access the course" button on the Thank You page
// sends people — your Teachable/course login page, member portal, etc.
export const COURSE_ACCESS_URL = "https://sso.teachable.com/secure/1828254/identity/login/password";
